module.exports = {
  SOLID_LINE: 0,
  ACC_LINE: 1,
  SCENERY_LINE: 2
};



// WEBPACK FOOTER //
// ./core/lines/LineTypes.js